let currentSelf = null;
const documentClickEvent = (e) => {
  var _a;
  if (!currentSelf) return;
  if (e.target.closest(`.${currentSelf.CSSClasses.calendar}`)) return;
  (_a = currentSelf.HTMLElement) == null ? void 0 : _a.classList.add(currentSelf.CSSClasses.calendarHidden);
  document.removeEventListener("click", documentClickEvent, { capture: true });
};
const handlerInput = (self) => {
  var _a;
  if (!self || !self.input) return;
  currentSelf = self;
  (_a = self.HTMLInputElement) == null ? void 0 : _a.addEventListener("click", () => {
    var _a2;
    (_a2 = self.HTMLElement) == null ? void 0 : _a2.classList.remove(self.CSSClasses.calendarHidden);
    document.addEventListener("click", documentClickEvent, { capture: true });
  });
};
export {
  handlerInput as default
};
